import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative w-full bg-viridian-200 p-4 md:p-10" }
const _hoisted_2 = { class: "flex w-full items-end space-x-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex gap-4" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "md:absolute md:right-0 md:bottom-0 md:right-8 md:top-1/2 md:-translate-y-1/2 text-concrete-700" }
const _hoisted_9 = {
  key: 0,
  class: "inline-block pr-4"
}

import { ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useSearchStore } from "~/js/store/search";

import { getGlobalTranslation } from "~/js/composables/translations";

interface Props {
	searchQuery?: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FieldSearch',
  props: {
    searchQuery: {}
  },
  setup(__props: any) {

const props = __props;
const search = useSearchStore();
const { cards, loading, pagination, filters } = storeToRefs(search);

// Create a reactive reference for the search query
const searchQuery = ref(props.searchQuery || "");

const onClear = () => {
	searchQuery.value = "";

	onSearch();
};

const onSearch = () => {
	search.setSearch(searchQuery.value);
};

onMounted(() => {
	// Initialize search with the passed query or fallback to "*"
	if (props.searchQuery && props.searchQuery.trim() !== "") {
		searchQuery.value = props.searchQuery;
		search.setSearch(props.searchQuery);
	} else {
		search.setSearch("*");
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(filters).searchQuery !== '*')
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(pagination).totalResults), 1),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("span", null, _toDisplayString(_unref(getGlobalTranslation)("results for")), 1)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(getGlobalTranslation)("What's new?")), 1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
        class: "block w-full py-1.5 border-b border-solid border-viridian-500 bg-transparent font-primary md:text-3xl text-black placeholder:text-gray-400 sm:leading-6",
        type: "text",
        placeholder: _unref(getGlobalTranslation)('What would you like to find on the website?'),
        onKeyup: onSearch
      }, null, 40, _hoisted_7), [
        [_vModelText, searchQuery.value]
      ]),
      _createElementVNode("div", _hoisted_8, [
        (searchQuery.value == '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fa-solid fa-2x fa-magnifying-glass" }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "p-1 pl-2 pr-4",
              "data-tag-category": "search",
              "data-tag-action": "click",
              "data-tag-label": "clear",
              onClick: onClear
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fa-regular fa-2x fa-times" }, null, -1)
            ]))]))
      ])
    ])
  ]))
}
}

})